import React from "react"
import Components from ".."
import { blokType, sbAssetType } from "../../types"

import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroCard,
  StyledHeroIcon,
  StyledHeroLabel,
  StyledHeroTitle,
  StyledHeroDescription,
  StyledHeroButtons,
  StyledBgImg,
} from "./partials"

export interface HeroLeftProps {
  icon: sbAssetType
  label: string
  title: string
  description: string
  cta_button: blokType[]
  background_image: blokType[]
  background_color: string
  id: string
  custom_id: string
}

export const HeroLeftCmp: React.FC<HeroLeftProps> = ({
  icon,
  label,
  title,
  description,
  cta_button,
  background_image,
  background_color,
  id,
  custom_id,
}) => {
  return (
    <StyledHero
      id={custom_id ? custom_id : id}
      background_color={background_color}
    >
      {background_image && background_image.length > 0 && (
        <StyledBgImg>
          {background_image.map((content) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
        </StyledBgImg>
      )}
      <StyledHeroContainer>
        <StyledHeroCard>
          {icon.filename && <StyledHeroIcon src={icon.filename} />}
          {label && <StyledHeroLabel>{label}</StyledHeroLabel>}
          {title && <StyledHeroTitle>{title}</StyledHeroTitle>}
          {description && (
            <StyledHeroDescription>{description}</StyledHeroDescription>
          )}

          {cta_button && cta_button.length > 0 && (
            <StyledHeroButtons>
              {cta_button.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </StyledHeroButtons>
          )}
        </StyledHeroCard>
      </StyledHeroContainer>
    </StyledHero>
  )
}
